
import { Button, EmptyStateLayout, InvalidPermissionsSVG } from '@panwds/react-ui'

const PermissionError = ({ heading = '', url = '' }) => {
  return (
    <div className='tw-pb-5 tw-pt-5 tw-border-solid cm-border-[#DADBDB] dark:cm-border-[#242424] tw-bg-white dark:tw-bg-gray-1050'>
      <EmptyStateLayout description={heading} heading={'Invalid Permission'} graphic={< InvalidPermissionsSVG width={200} height={200} />} actions={<Button appearance="secondary" onClick={(e) => {
        e.preventDefault()
        window.open(url, '_blank')
      }
      } >Learn More</Button>} />
    </div>
  )
}
export default PermissionError
